var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicantnotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 141,
    viewBox: "0 0 174 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_657_4905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.26396 39.4784C2.78769 39.7189 1.79022 41.0816 2.02961 42.5646L13.1216 113.305C13.361 114.788 14.7175 115.79 16.1938 115.55L67.4641 107.413C68.9404 107.173 69.9379 105.81 69.6985 104.327L60.4419 45.2499L43.405 33.2661L4.26396 39.4784Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.3942 47.3341L60.4412 45.29L43.4043 33.2661L45.3594 45.8511C45.5189 46.813 46.4366 47.4543 47.3942 47.3341Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.4043 33.2661L45.3594 45.8511C45.5189 46.813 46.3967 47.4543 47.3543 47.3341L60.4013 45.29",
    stroke: "white",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.5522 81.2414C32.2729 79.4378 32.1931 77.9549 32.2729 76.8326C32.3926 75.6703 32.7517 74.5882 33.3901 73.5461C33.7491 72.9048 34.188 72.3838 34.7067 71.8628C35.2254 71.3818 35.7042 70.8608 36.1032 70.3397C36.5022 69.8187 36.8613 69.2576 37.1007 68.6564C37.3401 68.0552 37.4199 67.2937 37.2603 66.4119C37.0209 64.929 36.4623 63.927 35.5446 63.4861C34.6269 63.0052 33.6294 62.8849 32.4724 63.0453C30.8764 63.2857 29.839 63.927 29.3602 64.929C28.8815 65.931 28.7219 67.2135 28.8017 68.7366L22.9365 69.6584C22.6971 68.1754 22.737 66.7727 23.0163 65.45C23.2956 64.1675 23.8542 63.0052 24.6123 62.0032C25.3703 61.0012 26.3678 60.1595 27.5249 59.5183C28.7219 58.877 30.0784 58.396 31.5946 58.1555C34.8663 57.6345 37.5795 57.9151 39.6941 58.9571C41.8088 59.9992 43.0855 62.0433 43.5643 65.0492C43.7239 66.0111 43.7638 66.8929 43.684 67.6544C43.6042 68.4159 43.4047 69.1374 43.1254 69.7786C42.8062 70.4199 42.4072 71.0612 41.9285 71.6624C41.4497 72.2636 40.8512 72.9048 40.2128 73.5862C39.6143 74.2275 39.1754 74.7886 38.8163 75.2695C38.4572 75.7906 38.2178 76.3116 38.0981 76.8326C37.9784 77.3537 37.8987 77.8747 37.9385 78.4358C37.9784 78.9969 38.0183 79.5981 38.138 80.2795L32.5522 81.2414ZM33.789 90.099L32.8315 84.087L38.9759 83.1251L39.9335 89.1371L33.789 90.099Z",
    fill: "#C0C0C0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.5,
    d: "M72.6173 88.4556L75.4502 89.0968L65.1562 132.463H59.291L72.6173 88.4556Z",
    fill: "#E8A600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M63.4004 81.4817C65.7544 89.698 67.1908 96.5516 68.1085 101.562",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M74.1058 88.87L68.4629 87.2639L56.1724 130.837L61.8153 132.443L74.1058 88.87Z",
    fill: "#1865C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.5,
    d: "M79.5181 88.4956C93.7311 88.4956 105.253 76.9216 105.253 62.6443C105.253 48.367 93.7311 36.793 79.5181 36.793C65.3051 36.793 53.7832 48.367 53.7832 62.6443C53.7832 76.9216 65.3051 88.4956 79.5181 88.4956Z",
    fill: "#CDEBF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M79.5192 33.4263C63.4798 33.4263 50.4727 46.4922 50.4727 62.6042C50.4727 78.7162 63.4798 91.7822 79.5192 91.7822C95.5586 91.7822 108.566 78.7162 108.566 62.6042C108.566 46.4922 95.5586 33.4263 79.5192 33.4263ZM79.5192 87.0528C66.0732 87.0528 55.2206 76.111 55.2206 62.6443C55.2206 49.1375 66.1131 38.2358 79.5192 38.2358C92.9652 38.2358 103.818 49.1776 103.818 62.6443C103.818 76.111 92.9253 87.0528 79.5192 87.0528Z",
    fill: "#1865C1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M80.8362 45.33C80.6766 45.6506 80.6766 46.0514 80.7963 46.4522C81.0756 47.2137 81.9134 47.5745 82.6715 47.2939C84.0281 46.7729 85.5044 46.5725 86.9407 46.6526C88.5367 46.7729 89.7337 47.2538 90.3321 47.5344C91.0104 47.855 92.4867 48.5364 93.5241 50.0193C95.0402 52.1035 94.8806 54.5082 94.7609 55.4701C94.6412 56.2717 95.1998 56.9932 95.9978 57.1134C96.7958 57.2336 97.514 56.6725 97.6337 55.8709C97.8332 54.2677 97.8731 51.1415 95.8382 48.336C94.3221 46.2518 92.367 45.33 91.5291 44.9292C90.6114 44.4883 89.0554 43.9272 87.1003 43.807C85.265 43.6867 83.3897 43.9673 81.6341 44.6086C81.275 44.7288 80.9958 45.0094 80.8362 45.33Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M98.5907 132.463H55.38C53.7042 132.463 52.3477 131.1 52.3477 129.417V127.453H98.5907V132.463Z",
    fill: "#2A83C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M130.789 132.463H83.6678C81.8325 132.463 80.5158 130.86 80.7153 128.896L84.2663 98.0346C84.5057 96.0707 86.1815 94.4675 88.0168 94.4675H135.138C136.973 94.4675 138.29 96.0707 138.09 98.0346L134.539 128.896C134.34 130.9 132.624 132.463 130.789 132.463Z",
    fill: "#2A83C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M135.338 132.463H88.2167C86.3813 132.463 85.0646 130.86 85.2641 128.896L88.8151 98.0346C89.0545 96.0707 90.7303 94.4675 92.5657 94.4675H139.687C141.522 94.4675 142.839 96.0707 142.639 98.0346L139.088 128.896C138.889 130.9 137.173 132.463 135.338 132.463Z",
    fill: "#3897E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M142.679 99.8381L139.128 129.096C139.128 129.096 139.288 132.463 133.781 132.463C128.275 132.463 102.939 132.463 102.939 132.463C106.251 132.423 117.862 131.942 128.555 123.164C139.208 114.427 142.001 103.125 142.679 99.8381Z",
    fill: "#5FBBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M141.682 103.606C140.605 107.093 138.011 113.866 131.827 120.199C125.683 126.451 119.099 129.176 115.668 130.339",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M113.991 116.592H112.355L113.393 109.858H115.029L113.991 116.592Z",
    fill: "#FEC02D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M116.146 116.591H114.51L115.228 111.942H116.864L116.146 116.591Z",
    fill: "#FEC02D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M67.9487 37.5547C65.5547 38.9174 59.5698 42.725 55.6198 50.4202C51.7097 58.1155 52.0688 65.2096 52.388 67.935",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M70.861 118.876L69.9434 112.303",
    stroke: "#262626",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M162.19 112.303H100.466C99.0692 112.303 97.9121 111.141 97.9121 109.738V64.3678C97.9121 62.965 99.0692 61.8027 100.466 61.8027H162.19C163.586 61.8027 164.743 62.965 164.743 64.3678V109.778C164.743 111.181 163.626 112.303 162.19 112.303Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.5,
    d: "M164.743 67.6143V64.3278C164.743 62.925 163.586 61.7627 162.19 61.7627H100.466C99.0692 61.7627 97.9121 62.925 97.9121 64.3278V67.6143H164.743Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M101.383 65.0091C101.383 65.45 101.024 65.8107 100.585 65.8107C100.146 65.8107 99.7871 65.45 99.7871 65.0091C99.7871 64.5682 100.146 64.2075 100.585 64.2075C101.024 64.2075 101.383 64.5682 101.383 65.0091Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M103.897 65.0091C103.897 65.45 103.538 65.8107 103.099 65.8107C102.66 65.8107 102.301 65.45 102.301 65.0091C102.301 64.5682 102.66 64.2075 103.099 64.2075C103.538 64.2075 103.897 64.5682 103.897 65.0091Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M106.451 65.0091C106.451 65.45 106.092 65.8107 105.653 65.8107C105.215 65.8107 104.855 65.45 104.855 65.0091C104.855 64.5682 105.215 64.2075 105.653 64.2075C106.092 64.2075 106.451 64.5682 106.451 65.0091Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.5,
    d: "M138.568 79.6381V76.3516C138.568 75.2694 137.691 74.3877 136.613 74.3877H117.701C116.624 74.3877 115.746 75.2694 115.746 76.3516V79.6381V101.481C115.746 102.564 116.624 103.445 117.701 103.445H147.985C149.062 103.445 149.94 102.564 149.94 101.481V81.602C149.94 80.5199 149.062 79.6381 147.985 79.6381H138.568Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M136.654 84.2073L132.823 88.0549L129.033 84.2073L126.719 86.5319L130.509 90.3394L126.719 94.1871L129.033 96.5117L132.823 92.6641L136.654 96.5117L138.928 94.1871L135.137 90.3394L138.928 86.5319L136.654 84.2073Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M100.465 61.7627H162.189C163.585 61.7627 164.742 62.925 164.742 64.3278V109.738",
    stroke: "white",
    strokeWidth: 0.274,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M169.771 141H4.2692C1.91516 141 0 139.076 0 136.711C0 134.347 1.91516 132.423 4.2692 132.423H169.771C172.125 132.423 174.04 134.347 174.04 136.711C174 139.116 172.125 141 169.771 141Z",
    fill: "#FEC02D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_4905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 141,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantnotfound);
export default __webpack_public_path__ + "static/media/applicantnotfound.dee9775ae30d3cfff7028201127b5e89.svg";
export { ForwardRef as ReactComponent };